// extracted by mini-css-extract-plugin
export var bounce = "_ox-1";
export var generatingText = "_ox-6";
export var lightning = "_ox-4";
export var popup = "_ox-5";
export var progressBar = "_ox-7";
export var progressFill = "_ox-8";
export var progressShimmer = "_ox-9";
export var progressText = "_ox-a";
export var shimmer = "_ox-3";
export var uploadIcon = "_ox-0";
export var uploadingText = "_ox-2";